import { IntlProvider } from "react-intl";

import enMessages from "../locales/messages/en.json";
import trMessages from "../locales/messages/tr.json";

import { useContext } from "react";
import { AppContext } from "./AppContext";

const allMessages = {
  en: enMessages,
  tr: trMessages,
};

export default function LocaleProvider({ children }) {
  const { locale } = useContext(AppContext);
  const messages = allMessages[locale];
  return (
    <IntlProvider locale={locale} messages={messages} onError={() => {}}>
      {children}
    </IntlProvider>
  );
}

export { LocaleProvider };
